import state from '../../store/main/state'
import Message from "../../models/Messages/Message";

/**
 * @param roomId {string}
 * @param params {object}
 * @returns {AxiosPromise<any>}
 */
const fetchMessages = (roomId, params= {}) => {
    return state.client.get(`/v2/messenger/message/list/${roomId}`, {
        params: params
    }).then(({data}) => {
        const items = data || [];
        return items.map(item => new Message(item));
    });
};

const fetchInitials = (roomId) => {
    return state.client.get(`/v2/messenger/message/list/${roomId}/initial`)
        .then(({data}) => {
            const items = (data && data.messages) || [];
            return items.map(item => new Message(item));
        });
}

export {
    fetchMessages,
    fetchInitials
}